module.exports = __webpack_public_path__ + "img/menu-alerta.e482dcc1.png";